<template>
	<div ref="menuEl" class="btn_more">
		<button
			type="button"
			class="btn_toggle"
			aria-label="btn_toggle"
			:class="{ on: isOpen }"
			@click.stop.prevent="onToggleMoreMenu"
		>
			<IconMenu width="24" :icon-color="!Boolean(route.query.isMoreMenuOpen) ? '#fff' : '#ff5e00'" />
		</button>
		<DesktopMoreMenu v-if="Boolean(route.query.isMoreMenuOpen) && displayStore.isDesktop" />
	</div>
</template>

<script setup lang="ts">
// core
import { ref } from 'vue';
import { useRoute } from 'vue-router';
import { onClickOutside } from '@vueuse/core';

import IconMenu from '@/components/atom/icon/IconMenu.vue';
// store
import { useDisplayStore } from '@/stores/display';
// util
import { closeMenuModal, openMenuModal } from '@/utils/function/modalMenu';

// component
import DesktopMoreMenu from './DesktopMoreMenu.vue';

// -----variable-----
const isOpen = ref(false);
const menuEl = ref();
const displayStore = useDisplayStore();
const route = useRoute();

// -----function-----
//더보기 메뉴 열기 닫기 함수
const onToggleMoreMenu = () => {
	if (route.query.isMoreMenuOpen && displayStore.isDesktop) {
		closeMenuModal();
	} else {
		openMenuModal({ menu: 'More' });
	}
};

//외부 클릭 시 실행 함수
onClickOutside(menuEl, () => {
	if (route.query.isMoreMenuOpen && displayStore.isDesktop) closeMenuModal();
});
</script>

<style lang="scss" scoped>
.btn_more {
	position: relative;
}
</style>
